import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { PAGE_HOME, PAGE_THREATS, PAGE_OFFER } from '../../config/pages';

import Home from './home/Home';
import FooterSmall from './common/FooterSmall';
import Offer from './Offer';
import { companyInfoPropsType } from '../helpers/fetchCmsContent';

const MainContent = ({
    t, openPage, language, page, subpage, preloaderDone, pageTransitionState, breakpoint, noTransition, consents, claim, companyInfo
}) => {
    const mainClassName = cx('container-main-content', {
        home: page === PAGE_HOME,
        open: page === PAGE_HOME || page === PAGE_THREATS || page === PAGE_OFFER
    });


    return (
        <div className={ mainClassName } id={ mainClassName }>
            {!subpage && <Home
              t={ t }
              openPage={ openPage }
              language={ language }
              page={ page }
              breakpoint={ breakpoint }
              noTransition={ noTransition }
              preloaderDone={ preloaderDone }
            />}
            {page === PAGE_HOME && (

            <FooterSmall
              t={ t }
              openPage={ openPage }
              language={ language }
              type="home"
              claim={ claim }
            />
                )
            }
            <Offer
              t={ t }
              openPage={ openPage }
              language={ language }
              page={ page }
              subpage={ subpage }
              pageTransitionState={ pageTransitionState }
              breakpoint={ breakpoint }
              consents={ consents }
              claim={ claim }
              companyInfo={ companyInfo }
            />
        </div>
    );
};

MainContent.defaultProps = {
    subpage: null,
    companyInfo: null
};

MainContent.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    subpage: PropTypes.string,
    preloaderDone: PropTypes.bool.isRequired,
    pageTransitionState: PropTypes.string.isRequired,
    breakpoint: PropTypes.string.isRequired,
    noTransition: PropTypes.bool.isRequired,
    consents: PropTypes.objectOf(Object).isRequired,
    claim: PropTypes.string.isRequired,
    companyInfo: companyInfoPropsType
};

export default MainContent;



// WEBPACK FOOTER //
// ./src/components/content/MainContent.jsx